import React, { useState } from "react";
import { Alert, Icon, Select } from "antd";
import I18n from "../../common/I18n";

const WarehouseSelect = ({ value, onChange, warehouses }) => (
  <Select
    showSearch
    value={ warehouses.some(w => w.id === value) ? value : undefined}
    onChange={onChange}
    placeholder={`Select a ${I18n.t('general.warehouse_small')}`}
    filterOption={(input, option) => {
      const children = option?.props?.children;
      if (children && children.length > 0) {
        if (Array.isArray(children)) {
          return children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } else {
          return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
      }
      return false;
    }}
    style={{ width: "100%" }}
  >
    {/* <Select.Option key={""} value={""}>
      ---Select---
    </Select.Option> */}
    {warehouses.map(warehouse => (
      <Select.Option key={warehouse.id} value={warehouse.id}>
        {warehouse.wh_name || warehouse.name}
      </Select.Option>
    ))}
  </Select>
);

// ─── Shared alerts ────────────────────────────────────────────────────────────
const ZipCodeAlerts = ({ zipcode, warehouses, locationType, warningText }) => {

  return (
  <Alert
    type="warning"
    showIcon
    message={""}
    description={
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 6 }}>
        <span style={{ fontSize: 13, color: "#444" }}>
          {warningText &&
            <b>{warningText}</b>}
        </span>
      </div>
    }
  />
);
};

// ─── PICKUP layout ────────────────────────────────────────────────────────────
const PickupContent = ({ warehouses, selectedWarehouseId, setSelectedWarehouseId, warningText }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
    <ZipCodeAlerts  warehouses={warehouses} locationType="Pickup" warningText={warningText} />
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{ fontWeight: 500, fontSize: 14 }}>Select Pickup {I18n.t('general.warehouse')}</label>
      {warehouses && warehouses.length > 0 && (
        <WarehouseSelect
          value={selectedWarehouseId}
          onChange={setSelectedWarehouseId}
          warehouses={warehouses}
        />
      )}
    </div>
  </div>
);

// ─── DELIVERY layout ──────────────────────────────────────────────────────────
const DeliveryContent = ({ warehouses, selectedWarehouseId, setSelectedWarehouseId, warningText , setDeliveryWarehouseID }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
    <ZipCodeAlerts  warehouses={warehouses} locationType="Delivery" warningText={warningText} />
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{ fontWeight: 500, fontSize: 14 }}>Select Delivery {I18n.t('general.warehouse')}</label>
      {warehouses && warehouses.length > 0 && (
        <WarehouseSelect
          value={selectedWarehouseId}
          onChange={(value) => {
            setSelectedWarehouseId(value);
            setDeliveryWarehouseID(value);
          }}
          warehouses={warehouses}
        />
      )}
    </div>
  </div>
);

// ─── Main component (inner content only, no Modal wrapper) ────────────────────
export const ZipCodeWhModal = ({ type, warehouses = [], selectedWarehouseId, setSelectedWarehouseId, setDeliveryWarehouseID = () => {}, warningText }) => {

  const sharedProps = { warehouses, selectedWarehouseId, setSelectedWarehouseId, setDeliveryWarehouseID, warningText };

  switch (type) {
    case "PICKUP":
      return <PickupContent {...sharedProps} />;
    case "DELIVERY":
      return <DeliveryContent {...sharedProps} />;
    default:
      return null;
  }
};